import { IDefineCommand } from 'core-ts-types';
angular
  .module('capability-ng-scheduler')
  .service(
    'deleteTermLocationPreferencesCommand',
    function deleteTermLocationPreferencesCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      log: any
    ) {
      'use strict';

      return defineCommand(
        'deleteTermLocationPreferencesCommand',
        function deleteTermLocationPreferencesCommand(deferred, termId, campusId) {
          $http.delete('/cat/student/term/' + termId + '/campus/' + campusId + '/').then(
            (response) => {
              deferred.resolve(response.data);
            },
            (response) => {
              log.issue('failed to delete term location preferences');
              deferred.reject(response.data);
            }
          );
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/commands/delete_term_location_preferences_command.ts